import { NgModule } from '@angular/core';
import { CheckIconComponent } from './check-icon.component';
import { CrossIconComponent } from './cross-icon.component';
import { MaterialModule } from '../../../material.module';
import { SvgIconModule } from '../../../ui-kit/svg-icon/svg-icon.module';

@NgModule({
  imports: [MaterialModule, SvgIconModule],
  declarations: [CheckIconComponent, CrossIconComponent],
  exports: [CheckIconComponent, CrossIconComponent],
})
export class IconsModule {}
